import {ExtendableError} from '@bluedrop-learning-networks/frontend-utils/errors';

export class OrganizationKeyError extends ExtendableError {}

export default function getOrganizationKey(hostname: string = window.location.hostname) {
	try {
		const chunks = hostname.split('.');
		if (chunks.length < 3) {
			throw new Error('Hostname does not contain a third level domain.', {cause: {hostname}});
		}
		return chunks[0];
	} catch (cause) {
		throw new OrganizationKeyError('Organization key extraction has failed.', {cause});
	}
}
